import { EvChargingPoints, EvGuestChargingProcesses, StartChargingProcessParams } from './ev-types';
import { createGet, createPost } from './util';

const get = createGet('power');
const post = createPost('power');

export async function getAvailableChargingPoints() {
  const result = await get<EvChargingPoints>('/getAvailableChargingPoints');
  return result.data;
}

export async function startChargingProcess(reqData: StartChargingProcessParams) {
  const result = await post<{ _id: string }>('/startChargingProcess', {
    data: reqData,
  });
  return result.data;
}

export async function getChargingProcessesForGuest() {
  const result = await get<EvGuestChargingProcesses>('/getChargingProcessesForGuest');
  return result.data;
}

export async function abortChargingProcess(reqData: { _id: string }) {
  const result = await post('/abortChargingProcess', {
    data: reqData,
  });
  return result.data;
}
